import { Grid, Skeleton } from '@mui/material'


const LoansSkeleton = () => {
    return (
        <Grid className='h-[calc(100svh-60px)] overflow-y-auto mt-5' container gap={"1rem"} padding={"20px"}>
            {[...Array(4)].map(() => (
                <Skeleton animation="wave" width={"100%"} height={130} sx={{ transform: 'unset' }} />
            ))}
        </Grid>
    )
}

export default LoansSkeleton